import styled from 'styled-components';

export const BackgroundShadow = styled.div`
    position: absolute;
    display: ${props => props.open ? 'flex' : ' none'};
    width: 400px;
    height: 500px;
    box-shadow: 0 0 1px #A7A7A7;
    background-color: #000;
    opacity: 0.9;
    top: 50%;
    right: 50%;
    transform: translate(43%, -50%);
`;

export const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 238px;
    height: 204px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #D2D2D2;
    border-radius: 2px;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    opacity: 1 !important;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #A7A7A7;
    box-sizing: border-box;
    padding: 10px;
    span {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        color: #4D4D4D;
    }
`
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
`
export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    div {
        display: flex;
        flex-direction: column;
    }
`

export const PhoneNumber = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #4D4D4D;
`

export const ItemTitle = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #4D4D4D;
`